import { SvgIcon } from "@mui/material"

const AnDIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22">
      <path
        d="M10.005 2.95696L18.0957 9.06751V19.5258H1.91436V9.06751L10.005 2.95696ZM10.005 0.580078L0 8.14647V21.4174H20V8.14647L10.005 0.580078Z"
        fill="inherit"
      />
      <mask id="mask0_348_960" maskUnits="userSpaceOnUse" x="3" y="5" width="14" height="15">
        <rect x="3" y="5.58008" width="14" height="14" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_348_960)">
        <path
          d="M7.08333 15.4967H11.1667V14.3301H7.08333V15.4967ZM7.08333 13.1634H12.9167V11.9967H7.08333V13.1634ZM7.08333 10.8301H12.9167V9.66341H7.08333V10.8301ZM5.91667 17.8301C5.59583 17.8301 5.32108 17.7159 5.09242 17.4877C4.86414 17.259 4.75 16.9842 4.75 16.6634V8.49674C4.75 8.17591 4.86414 7.90116 5.09242 7.67249C5.32108 7.44422 5.59583 7.33008 5.91667 7.33008H14.0833C14.4042 7.33008 14.6789 7.44422 14.9076 7.67249C15.1359 7.90116 15.25 8.17591 15.25 8.49674V16.6634C15.25 16.9842 15.1359 17.259 14.9076 17.4877C14.6789 17.7159 14.4042 17.8301 14.0833 17.8301H5.91667ZM5.91667 16.6634H14.0833V8.49674H5.91667V16.6634Z"
          fill="inherit"
        />
      </g>
    </svg>
  )
}

export default AnDIcon
